import React from 'react'
import Button from 'components/button.js'
import { ReactComponent as ArrowUp } from 'svgs/arrow-up-black.svg'

export default function BackToTop({ style }){
    return(        
        <Button
            onClick={() => {
                if(typeof window === 'undefined') return
                window.scroll({ top: 0, behavior: 'smooth' })
            }}
            style={style}
            variant='primary'
            className='mx-auto'
            css={{
                '& path': {
                    transition: 'all .25s ease',
                    fill: 'white'
                },
            }}
        >
            Back to Top
            <ArrowUp />
        </Button>
    )
}
